import { useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useAccount } from '../account/store.ts';
import { BrandingEditor } from '../branding/BrandingEditor.tsx';
import { has } from '../plans/features.ts';
import { openPaywallFor, useFlags } from '../plans/gate.ts';
import { Button } from '../ui/Button.tsx';
import { IconButton } from '../ui/IconButton.tsx';
import { LockBadge } from '../ui/LockBadge.tsx';

/** Personal quote branding (Starter+). Company branding lives on the Team page. */
export function BrandingScreen() {
  const navigate = useNavigate();
  const { session, me, ready } = useAccount(useShallow((s) => ({ session: s.session, me: s.me, ready: s.ready })));
  const flags = useFlags(me?.personalScope ?? null);
  useEffect(() => {
    if (ready && !session) void navigate({ to: '/signin', search: { next: '/branding' }, replace: true });
  }, [ready, session, navigate]);
  const allowed = has(flags, 'branded_quote');
  return (
    <main
      className="min-h-dvh"
      style={{ paddingTop: 'var(--safe-top)', paddingBottom: 'calc(var(--safe-bottom) + 32px)' }}
    >
      <div className="flex min-h-11 items-center gap-2 px-2">
        <IconButton
          icon={ArrowLeft}
          label="Back"
          onClick={() => (history.length > 1 ? history.back() : void navigate({ to: '/account' }))}
        />
        <h1 className="t-title">Quote branding</h1>
      </div>
      <div className="mx-auto flex max-w-[680px] flex-col gap-6 p-4">
        {!allowed ? (
          <div className="flex items-center justify-between gap-3 rounded-md border border-[rgba(255,181,71,0.45)] bg-accent-soft p-3">
            <span className="t-label">Put your logo, colors and terms on every quote.</span>
            <div className="flex items-center gap-2">
              <LockBadge flag="branded_quote" />
              <Button size="sm" variant="primary" onClick={() => openPaywallFor('branded_quote')}>
                Upgrade
              </Button>
            </div>
          </div>
        ) : null}
        {me ? (
          <BrandingEditor scope={me.personalScope} canEdit={allowed} templates={has(flags, 'quote_templates')} />
        ) : (
          <p className="t-body text-dim">Loading…</p>
        )}
      </div>
    </main>
  );
}
